import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, renderSlot as _renderSlot, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  id: "navMenu",
  class: "flex-container-row flex-item align-center"
}
const _hoisted_2 = ["onClick"]
const _hoisted_3 = {
  key: 0,
  class: "flex-container-row pad20 gap5 align-center"
}
const _hoisted_4 = {
  id: "navMenu",
  class: "flex-container-row align-center padh10"
}
const _hoisted_5 = { class: "k-link k-menu-link" }
const _hoisted_6 = {
  key: 1,
  class: "selected-menu-item text-cutoff"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_my_icon = _resolveComponent("my-icon")!
  const _component_drop_down_button = _resolveComponent("drop-down-button")!
  const _component_top_banner_toolbar = _resolveComponent("top-banner-toolbar")!
  const _component_dynamic_view_switcher = _resolveComponent("dynamic-view-switcher")!

  return (_openBlock(), _createBlock(_component_dynamic_view_switcher, null, {
    large: _withCtx(() => [
      (_ctx.showNavigationBarOnLargeScreen)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleItems, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                key: item.textName,
                class: "flex-container-row pad20 gap5 align-center",
                style: _normalizeStyle(item.align === 'right' ? 'margin-left: auto;' : '')
              }, [
                (item.icon != null)
                  ? (_openBlock(), _createBlock(_component_my_icon, {
                      key: 0,
                      icon: item.icon.name,
                      color: item.icon.color
                    }, null, 8, ["icon", "color"]))
                  : _createCommentVNode("", true),
                _createElementVNode("a", {
                  href: "#",
                  onClick: _withModifiers(($event: any) => (_ctx.onMenuItemClick(item)), ["prevent"]),
                  class: _normalizeClass([item.routeName != null && item.routeName == _ctx.activeMenuItem?.routeName ? 'router-link-active' : '', 'dark-header-link'])
                }, _toDisplayString(_ctx.localize(item.textName)), 11, _hoisted_2)
              ], 4))
            }), 128)),
            (_ctx.renderNavigationTemplate)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _renderSlot(_ctx.$slots, "navigation")
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    small: _withCtx(() => [
      _createElementVNode("div", _hoisted_4, [
        (_ctx.showContextMenuOnSmallScreen)
          ? (_openBlock(), _createBlock(_component_drop_down_button, {
              key: 0,
              icon: "menu",
              items: _ctx.visibleItems,
              "item-render": "itemRender",
              onItemclick: _ctx.onMenuItemSelect,
              "fill-mode": "outline",
              class: "nav-menu-button"
            }, {
              itemRender: _withCtx(({props}) => [
                _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.localize(props.item.textName)), 1)
              ]),
              _: 1
            }, 8, ["items", "onItemclick"]))
          : _createCommentVNode("", true),
        (_ctx.activeMenuItemText)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.activeMenuItemText), 1))
          : _createCommentVNode("", true),
        _renderSlot(_ctx.$slots, "navigation"),
        _createVNode(_component_top_banner_toolbar, { class: "flex-item-right" })
      ])
    ]),
    _: 3
  }))
}